import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// src/core/components/layout/Header/index.tsx
import { useState, useEffect } from "react";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";
import MenuOverlay from "./MenuOverlay";
import CartOverlay from "../../shop/Cart/CartOverlay";
const Header = () => {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const toggleCartOverlay = () => {
        setIsCartOpen(!isCartOpen);
    };
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    useEffect(() => {
        const mobilemenu = document.getElementById("menu-btn-mobile");
        const overlay = document.getElementById("mobile-menu-overlay");
        if (!mobilemenu || !overlay)
            return;
        function navToggle() {
            if (mobilemenu && overlay) {
                mobilemenu.classList.toggle("open");
                overlay.style.transition = "transform 0.3s ease";
                overlay.style.transform =
                    overlay.style.transform === "translateY(0%)"
                        ? "translateY(-100%)"
                        : "translateY(0%)";
            }
        }
        mobilemenu.addEventListener("click", navToggle);
        return () => {
            mobilemenu.removeEventListener("click", navToggle);
        };
    }, []);
    return (_jsxs("div", { className: "font-semibold poiret-one text-[17.85px] bg-primary-gradient-br", children: [_jsx(DesktopHeader, { toggleCartOverlay: toggleCartOverlay }), _jsx(MobileHeader, { toggleCartOverlay: toggleCartOverlay, toggleMobileMenu: toggleMobileMenu }), _jsx(MenuOverlay, { isOpen: isMobileMenuOpen, toggleMobileMenu: toggleMobileMenu }), _jsx(CartOverlay, { isOpen: isCartOpen, toggleCartOverlay: toggleCartOverlay })] }));
};
export default Header;
